import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generatePriceChangeIndicator} from '#core/application/modules/tiles/price-change-indicator/index.js';

import ODDS from './odds-button.palette-schema.yaml';

registerTileSchema(ODDS);

const generateOddsContainerConfig = (BACKGROUND, BORDER_COLOR, BORDER_RADIUS) => {
    return {
        ...resolveBackground(BACKGROUND),
        borderRadius: BORDER_RADIUS,
        ...(BORDER_COLOR !== 'transparent'
            ? {
                  borderStyle: 'solid',
                  borderWidth: 1,
                  borderColor: BORDER_COLOR,
              }
            : {
                  borderStyle: 'none',
              }),
    };
};

const BET_DISTRIBUTION_BAR_COLOR_STEPS = [
    {minimumPercent: 0, colorKey: 'COLOR_LOW'},
    {minimumPercent: 20, colorKey: 'COLOR_MID'},
    {minimumPercent: 51, colorKey: 'COLOR_HIGH'},
];

export function generateOddsButton(TILE) {
    const ODDS_TEXT_BASE = {
        textTransform: 'none', // Fix mojito weird default styles
    };

    return {
        view: {
            infoText: {
                style: {
                    ...ODDS_TEXT_BASE,
                    ...TILE.ODDS_INFO_TEXT,
                    fontSize: TILE.ODDS_PRICE_TEXT.fontSize, // Same as price text
                },
            },
            infoTextOverrides: {
                vertical: {...ODDS_TEXT_BASE, ...TILE.ODDS_INFO_TEXT, lineHeight: '16px'},
                active: TILE.ODDS_SELECTED_INFO_TEXT,
            },
            priceTextEllipsis: {
                style: {
                    lineHeight: ODDS_TEXT_BASE.lineHeight,
                },
            },
            priceText: {
                base: ODDS_TEXT_BASE,
                active: TILE.ODDS_SELECTED_PRICE_TEXT,
                inactive: TILE.ODDS_PRICE_TEXT,
                decreaseColor: TILE.ODDS_PRICE_TEXT_DECREASE_COLOR,
                increaseColor: TILE.ODDS_PRICE_TEXT_INCREASE_COLOR,
            },
            unavailable: {
                ...ODDS_TEXT_BASE,
                ...TILE.ODDS_UNAVAILABLE_TEXT,
            },
            containerInactive: generateOddsContainerConfig(
                TILE.ODDS_BG,
                TILE.ODDS_BORDER_COLOR,
                TILE.ODDS_BORDER_RADIUS
            ),
            containerInactivehover: generateOddsContainerConfig(
                TILE.ODDS_HOVER_BG,
                TILE.ODDS_HOVER_BORDER_COLOR,
                TILE.ODDS_BORDER_RADIUS
            ),
            containerActive: generateOddsContainerConfig(
                TILE.ODDS_SELECTED_BG,
                TILE.ODDS_ACTIVE_BORDER_COLOR,
                TILE.ODDS_BORDER_RADIUS
            ),
            containerActivehover: generateOddsContainerConfig(
                TILE.ODDS_SELECTED_HOVER_BG,
                TILE.ODDS_ACTIVE_BORDER_COLOR,
                TILE.ODDS_BORDER_RADIUS
            ),
            containerDisabled: generateOddsContainerConfig(
                TILE.ODDS_DISABLED_BG,
                TILE.ODDS_BORDER_COLOR,
                TILE.ODDS_BORDER_RADIUS
            ),
            lockedIcon: icon(TILE.ODDS_LOCKED_ICON_COLOR, TILE.ODDS_LOCKED_ICON_SRC),
            priceChangeIndicator: generatePriceChangeIndicator(TILE.ODDS_PRICE_CHANGE_INDICATOR),
            distributionBar: {
                progressLineBackground: {
                    style: {
                        ...resolveBackground(TILE.ODDS_DISTRIBUTION_BAR.TRACK_BG),
                    },
                },
                progressLine: {
                    style: {
                        backgroundImage: 'none',
                    },
                },
            },
            distributionBarColors: BET_DISTRIBUTION_BAR_COLOR_STEPS.map(({minimumPercent, colorKey}) => ({
                minimumPercent,
                color: TILE.ODDS_DISTRIBUTION_BAR[colorKey],
            })),
        },
    };
}
